<template>
  <section class="silider-section">
    <div class="cardEspecial">
      <div class="card-content">
        <!--    <carousel
          :per-page="itemsPerPage"
          @page-change="handlePageChange"
          :paginationEnabled="false"
          :navigationEnabled="true"
        >
          <slide v-for="item in items" :key="item.key">
            <channel from="slider" :fi="fi" :config="item" @addChannel="addChannel"></channel>
          </slide>
        </carousel>-->
        <!--<button class="vNav vPrev" @click.prevent="slidePrev">
          <img src="/assets/img/prev.png" />
        </button>-->

        <!--<hooper :settings="hooperSettings" @slide="cslide" ref="carousel">
          <sldr v-for="item in items" :key="item.key">
            <channel :currents="currents" from="slider" :fi="fi" :config="item" @addChannel="addChannel"></channel>
          </sldr>
        </hooper>-->

        <carousel ref="micarousel" :perPageCustom="responsiveArray" @navigation-click="handlePageChange"
          :navigationEnabled="true" :paginationEnabled="false" navigationNextLabel="<img src='/assets/img/next.png' />"
          navigationPrevLabel="<img src='/assets/img/prev.png' />">
          <slide v-for="item in items" :key="item.key">
            <channel :currents="currents" from="slider" :fi="fi" :config="item" @addChannel="addChannel"></channel>
          </slide>
        </carousel>
        <!--<button class="vNav vNext" @click.prevent="slideNext">
          <img src="/assets/img/next.png" />
        </button>-->
      </div>
    </div>
  </section>
</template>


<script>
import { Hooper, Slide as sldr, Navigation as HooperNavigation } from "hooper";

import moment from "moment-timezone";

import { Carousel, Slide } from "vue-carousel";
import channel from "@/components/vchannel";

export default {
  name: "sliderVideoNotes",
  props: ["items", "fi", "lek", "currents"],
  components: { Carousel, Slide, channel, Hooper, sldr, HooperNavigation },
  data() {
    return {
      classCard: "card",
      itemsPerPage: 2,
      hooperSettings: {
        itemsToShow: 5,
        itemsToSlide: 4,
        centerMode: false,
        responsiveArray: [],
        breakpoints: {
          1600: {
            centerMode: false,
            itemsToShow: 10,
            itemsToSlide: 10
          },
          1460: {
            centerMode: false,
            itemsToShow: 9,
            itemsToSlide: 9
          },

          1300: {
            centerMode: false,
            itemsToShow: 9,
            itemsToSlide: 9
          },
          960: {
            itemsToShow: 7,
            itemsToSlide: 7
          },
          760: {
            itemsToShow: 5,
            itemsToSlide: 5
          },
          600: {
            itemsToShow: 3,
            itemsToSlide: 3
          },
          400: {
            itemsToShow: 3,
            itemsToSlide: 3
          },
          300: {
            itemsToShow: 2,
            itemsToSlide: 2
          }
        }
      }
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    console.log('beforemount slidechannels', this.fi)
    switch (this.fi) {
      case "T":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1440, 10],
          [1600, 12]
        ];
        break;
      case "R":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1440, 10],
          [1600, 12]
        ];

        break;
      case "TW":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1440, 10],
          [1600, 12]
        ];
        break;
      case "FB":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1140, 8],
          [1440, 10],
          [1600, 12]
        ];

        break;
      case "Y":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1440, 10],
          [1600, 12]
        ];
        break;
      case "PD":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1440, 10],
          [1600, 12]
        ];
        break;
      case "I":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1140, 8],
          [1440, 10],
          [1600, 12]
        ];
        break;
      case "TK":
        this.responsiveArray = [
          [320, 2],
          [480, 4],
          [768, 5],
          [1024, 8],
          [1140, 8],
          [1440, 10],
          [1600, 12]
        ];

        break;
    }

    this.handleResize();
  },
  mounted() { },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      console.log("more");
      this.$emit("loadMore", this.items);

      this.$refs.carousel.slideNext();
    },
    cslide(cs) {
      console.log("Current");
      console.log(cs);
      var fin = this.items.length - 1;
      // console.log(fin);
      if (fin == cs.currentSlide) {
        //llegamos al final?
        //  this.$emit("loadMore", this.items); //pedimos más items
      }
    },
    handlePageChange(page) {
      //  var paginaFinal = parseInt(this.items.length / this.itemsPerPage);

      if (page == "forward") {
        //llegamos al final?
        this.$emit("loadMore", this.items); //pedimos más items
      }
    },
    /*handlePageChange(page) { //hooper
      var paginaFinal = this.items.length / this.itemsPerPage - 1;
      if (page == paginaFinal) {
        //llegamos al final?
        this.$emit("loadMore", this.items); //pedimos más items
      }
    },*/
    addChannel(params) {
      this.$emit("addChannel", params);
    },
    handleResize() {
      var width = window.innerWidth;
      /**  var responsiveArray =
        this.responsiveArray[0][0] == 480
          ? this.responsiveArray.reverse()
          : this.responsiveArray; **/
      for (var i = 0; i < this.responsiveArray.length; i++) {
        var arr = this.responsiveArray[i];
        if (width >= arr[0]) {
          this.itemsPerPage = arr[1];
        }
      }
    },
    /*handleResize() {
      var width = window.innerWidth;
      if (width <= 768) {
        this.itemsPerPage = 1;
      } else {
        this.itemsPerPage = 2;
      }
    }*/
  }
};
</script>
<style scoped>
.vNav img {
  width: 10px;
}

.vNav {
  border: none;
  background-color: transparent;
}

.vPrev {
  position: absolute;
  z-index: 99999999;
  top: 50%;
  left: 5px;
}

.vNext {
  position: absolute;
  z-index: 99999999;
  top: 50%;
  right: 5px;
}

.silider-section {
  padding: 0px 10px;
}

.cardEspecial {
  background-color: none;
}

.folder-name {
  color: #00b99e !important;
}

.touchpad {
  cursor: pointer;
}

.img-avatar {
  height: 100%;
}

.folder .folder-image {
  border: solid 6px #ebf9ff;
  /*00B99E*/
  color: #00b99e;
}

.folder .folder-image:hover {
  background: #ebf9ff;
}

.folder-image .img-avatar {
  position: relative;
}

.folder-image .middle {
  height: auto;
  display: block;
  position: relative;
  transition: 0.5s ease;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.text {
  width: 100%;
  font-size: 16px;
}

.hooper-prev .icon {
  color: #00b99e;
}

.icon-arrowDown {
  fill: red !important;
}

.hooper {
  padding: 10px 0px;
  /* background-color: #fff;*/
  height: 100% !important;
}

.hooper .vpost {
  min-height: 160px;
}

@media screen and (min-width: 991px) {
  .hooper {
    padding: 0px 0px;
  }
}
</style>